import React, { useState } from 'react';
import Button from '../../../components/ui/Button';
import { Checkbox } from '../../../components/ui/Checkbox';
import Icon from '../../../components/AppIcon';
import { useLanguage } from '../../../contexts/LanguageContext';

const StepProfessionalServices = ({ data, onNext, onBack }) => {
  const { t } = useLanguage();
  const [selectedServices, setSelectedServices] = useState(data?.professionalServices || []);

  const services = [
    {
      id: 'photographer',
      name: t('professionalPhotography'),
      description: t('photographyDesc'),
      icon: 'Camera',
      price: '$350'
    },
    {
      id: 'stylist',
      name: t('propertyStyling'),
      description: t('stylingDesc'),
      icon: 'Palette',
      price: '$800'
    },
    {
      id: 'lawyer',
      name: t('legalServices'),
      description: t('legalServicesDesc'),
      icon: 'Scale',
      price: '$1,200'
    },
    {
      id: 'marketing',
      name: t('premiumMarketing'),
      description: t('marketingDesc'),
      icon: 'Megaphone',
      price: '$500'
    }
  ];

  const toggleService = (serviceId) => {
    if (selectedServices?.includes(serviceId)) {
      setSelectedServices(selectedServices?.filter(s => s !== serviceId));
    } else {
      setSelectedServices([...selectedServices, serviceId]);
    }
  };

  const handleSubmit = (e) => {
    e?.preventDefault();
    onNext({ professionalServices: selectedServices });
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold text-foreground mb-2">{t('professionalServicesTitle')}</h2>
        <p className="text-muted-foreground">{t('professionalServicesDesc')}</p>
      </div>

      <div className="space-y-4">
        {services?.map((service) => (
          <div
            key={service?.id}
            onClick={() => toggleService(service?.id)}
            className={`p-4 rounded-lg border-2 cursor-pointer transition-all ${
              selectedServices?.includes(service?.id)
                ? 'border-primary bg-primary/5' :'border-border hover:border-primary/50'
            }`}
          >
            <div className="flex items-start gap-4">
              <div className="flex-shrink-0">
                <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center">
                  <Icon name={service?.icon} size={24} color="var(--color-primary)" />
                </div>
              </div>
              <div className="flex-1">
                <div className="flex items-start justify-between mb-1">
                  <h3 className="font-semibold text-foreground">{service?.name}</h3>
                  <span className="text-sm font-semibold text-primary">{service?.price}</span>
                </div>
                <p className="text-sm text-muted-foreground">{service?.description}</p>
              </div>
              <div className="flex-shrink-0">
                <Checkbox
                  checked={selectedServices?.includes(service?.id)}
                  onChange={() => toggleService(service?.id)}
                />
              </div>
            </div>
          </div>
        ))}
      </div>

      {selectedServices?.length > 0 && (
        <div className="bg-muted rounded-lg p-4">
          <div className="flex items-center justify-between">
            <span className="font-semibold text-foreground">{t('totalAdditionalServices')}</span>
            <span className="text-xl font-bold text-primary">
              ${services
                ?.filter(s => selectedServices?.includes(s?.id))
                ?.reduce((sum, s) => sum + parseInt(s?.price?.replace(/[^0-9]/g, '')), 0)
                ?.toLocaleString()}
            </span>
          </div>
        </div>
      )}

      <div className="flex justify-between">
        <Button type="button" variant="outline" onClick={onBack} iconName="ArrowLeft">{t('back')}</Button>
        <Button type="submit" variant="default" iconName="ArrowRight" iconPosition="right">{t('continue')}</Button>
      </div>
    </form>
  );
};

export default StepProfessionalServices;